import React, { useState, useEffect } from "react";
import { Row, Col, Space, Form, Select, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import InvoicesList from "./Components/InvoicesList";
import InvoiceModal from "./Components/InvoiceModal";
import { FormattedMessage, useIntl } from "react-intl";
import CreateQuote from "features/Dashboard/CreateQuote";

function Invoices() {
  const intl = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle">
              <Col xs={24} md={24} lg={12}>
                <h4>
                  <FormattedMessage id="Invoice.Heading" />
                </h4>
                <p className="mt-5px">
                  <FormattedMessage id="Invoice.SubHeading" />
                </p>
              </Col>
              {/* <Col span={12} className="text-right">
                <Space>
                  <Button type="primary" onClick={handleOpenModal}>
                    <FormattedMessage id="Invoice.GenerateInvoice" />
                  </Button>
                </Space>
              </Col> */}
            </Row>
          </div>
          <InvoicesList CreateInvoiceVisible={true} />
        </div>
      </div>
      <CreateQuote
        open={isModalOpen}
        onCancel={handleCloseModal}
        type="invoice"
      />
    </>
  );
}
export default Invoices;
